import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page about-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "glass-card about-card" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eyebrowCompany), 1),
      _createElementVNode("h1", {
        innerHTML: _ctx.jsonData.about
      }, null, 8, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "about-text",
        innerHTML: _ctx.jsonData.aboutText
      }, null, 8, _hoisted_6)
    ])
  ]))
}